/**
 * Formats contact method identifiers into user-friendly display names
 * @param method - The technical method identifier from the backend
 * @returns User-friendly display name
 */
export function formatContactMethod(method: string): string {
  const methodMap: Record<string, string> = {
    'survey/link/sms/twilio': 'Survey/SMS',
    'survey': 'Survey/SMS',
    'voice call/retell': 'Voice Call',
    'ad-hoc questions to patient': 'Voice Call Survey',
  };

  return methodMap[method] || method;
}
